import { getLogActivityDecorator, getLogVerboseDecorator, LoggerFactory, } from '@metaos/mfs-telemetry';
import { MFS_FOLDERS_VERSION } from '../version';
export const logger = LoggerFactory.getInstance().getMfsLogger('metafolder');
/** A single decorator that works for both sync & async functions */
export const logActivity = getLogActivityDecorator(logger);
export const logVerbose = getLogVerboseDecorator(logger);
const FOLDERS_FEATURE_NAME = 'folders';
/** Update the Logger Context to include the Folds SDK version. */
export function setLoggerContext(loggerContext, sink) {
    loggerContext.appInfo.mfsFeature = FOLDERS_FEATURE_NAME;
    loggerContext.appInfo.mfsFeatureVersion = MFS_FOLDERS_VERSION;
    LoggerFactory.getInstance().setContext(loggerContext, sink);
}
//# sourceMappingURL=telemetry.js.map